module.exports = __webpack_public_path__ + "img/de_de.8586b0e7.svg";